import React from 'react';
import TreasurySplashScreenImage, {
    BalancesIcon,
    CashFlow,
    LinkIcon,
    SecureIcon
} from '../../../../components/icons/TreasurySplashScreenImage';
import Button from '../../../../components/button/Button';

const TreasurySplashScreen = ({
    onContinue,
    loading
}: {
    onContinue: () => void;
    loading: boolean;
}) => {
    return (
        <section className='w-full h-screen flex items-center justify-center'>
            <div className=' max-w-[474px] bg-white rounded-xl flex flex-col items-center gap-4 p-8'>
                <TreasurySplashScreenImage />
                <h1 className='text-deepMidnightBlue text-[20px] font-medium mb-2 text-center '>
                    Get started with Treasury
                </h1>
                <p className='text-deepMidnightBlue text-sm text-center '>
                    Request access to securely link your accounts, track
                    real-time balances, analyze cash positions, and make direct
                    payments.
                </p>

                <div className='w-[360px] my-4 p-6 border-gray rounded-2xl border space-y-4'>
                    <div className='flex items-center gap-2'>
                        <LinkIcon />
                        <p className='text-midnightHaze text-sm'>
                            Link and manage multiple bank accounts
                        </p>
                    </div>
                    <div className='flex items-center gap-2'>
                        <SecureIcon />
                        <p className='text-midnightHaze text-sm'>
                            Initiate secure payments
                        </p>
                    </div>
                    <div className='flex items-center gap-2'>
                        <BalancesIcon />
                        <p className='text-midnightHaze text-sm'>
                            View real-time and historical cash balances
                        </p>
                    </div>
                    <div className='flex items-center gap-2'>
                        <CashFlow />
                        <p className='text-midnightHaze text-sm'>
                            Monitor cash flow trends{' '}
                        </p>
                    </div>
                </div>

                <Button
                    onClick={onContinue}
                    text={loading ? 'Review in progress' : 'Request Access'}
                    className='w-full'
                    disabled={loading}
                    isLoading={loading}
                />
            </div>
        </section>
    );
};

export default TreasurySplashScreen;
